window.FASTCO_SW_ENDPOINT='https://cotizaciones-fastco.banxsword.workers.dev';

(function(){
  var form = document.getElementById('rentaForm');
  if(!form) return;
  var box = document.querySelector('[data-renta]');
  var PRECIO = 1200;
  if(box && box.dataset.precio){ var pz = parseInt(box.dataset.precio, 10); if(pz > 0) PRECIO = pz; }
  (function(){ if(window.jspdf) return; var sc = document.createElement('script'); sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'; sc.async = true; document.head.appendChild(sc); })();
  function mx(c){ return '$' + (c/100).toLocaleString('es-MX', {minimumFractionDigits:2, maximumFractionDigits:2}); }
  function construirPDF(d, folio, fecha, sub, iva, tot){
    var doc = new window.jspdf.jsPDF({unit:'mm', format:'a4'});
    doc.setFillColor(226,51,0); doc.rect(0,0,210,24,'F');
    doc.setTextColor(255,255,255); doc.setFont('helvetica','bold'); doc.setFontSize(19);
    doc.text('fastco.', 14, 15);
    doc.setFontSize(9.5); doc.setFont('helvetica','normal');
    doc.text('Cotizaci\u00f3n \u00b7 Programa Fastco Renta', 196, 15, {align:'right'});
    doc.setTextColor(20,20,20); doc.setFontSize(9);
    doc.text('Folio: ' + folio, 14, 33);
    doc.text('Fecha: ' + fecha, 14, 38.5);
    doc.text('Vigencia: 15 d\u00edas naturales', 14, 44);
    doc.setDrawColor(226,51,0); doc.setLineWidth(0.6); doc.line(14, 49, 196, 49);
    doc.setFont('helvetica','bold'); doc.setFontSize(10.5); doc.text('Solicitante', 14, 57);
    doc.setFont('helvetica','normal'); doc.setFontSize(9.5);
    doc.text('Nombre: ' + d.nombre, 14, 63.5);
    doc.text('Empresa: ' + d.empresa, 14, 69);
    doc.text('Estado: ' + d.estado, 14, 74.5);
    doc.text('Tel\u00e9fono: ' + d.tel + '   \u00b7   Correo: ' + d.correo, 14, 80);
    doc.setFont('helvetica','bold'); doc.setFontSize(10.5); doc.text('Concepto', 14, 92);
    doc.setFillColor(246,243,240); doc.rect(14, 96, 182, 9, 'F');
    doc.setFontSize(9); doc.text('Descripci\u00f3n', 16, 102); doc.text('Piezas', 128, 102); doc.text('P.U. mensual', 148, 102); doc.text('Importe', 196, 102, {align:'right'});
    doc.setFont('helvetica','normal');
    doc.text('Renta mensual de toallas de gimnasio 40 \u00d7 90 cm', 16, 111);
    doc.text('Plan Esencial: lavander\u00eda semanal, log\u00edstica y reposici\u00f3n incluidas', 16, 116);
    doc.text(String(d.qty), 128, 111);
    doc.text(mx(PRECIO), 148, 111);
    doc.text(mx(sub), 196, 111, {align:'right'});
    doc.line(14, 122, 196, 122);
    doc.text('Subtotal mensual', 148, 129); doc.text(mx(sub), 196, 129, {align:'right'});
    doc.text('IVA 16%', 148, 135); doc.text(mx(iva), 196, 135, {align:'right'});
    doc.setFont('helvetica','bold'); doc.setFontSize(10.5);
    doc.text('Total mensual', 148, 142); doc.text(mx(tot), 196, 142, {align:'right'});
    doc.setFont('helvetica','bold'); doc.setFontSize(10); doc.text('Condiciones del programa', 14, 156);
    doc.setFont('helvetica','normal'); doc.setFontSize(8.8);
    var cond = ['\u00b7 Plan Esencial: 1 ciclo semanal de lavander\u00eda con recolecci\u00f3n y entrega sin costo (Fastco Logistics).', '\u00b7 Reposici\u00f3n del 100% por desgaste normal; hasta 5% mensual de reposiciones extraordinarias sin costo.', '\u00b7 Excedente y piezas no devueltas: $75.00 MXN + IVA por pieza.', '\u00b7 Dotaci\u00f3n m\u00ednima del programa: 100 piezas; ajustable seg\u00fan el consumo real.', '\u00b7 Contrato m\u00ednimo de 2 meses; renovaci\u00f3n mensual. Precios en MXN m\u00e1s IVA. Cobertura CDMX y \u00c1rea Metropolitana.', '\u00b7 Un agente confirma la dotaci\u00f3n final, el calendario de visitas y la fecha de arranque.'];
    for(var i=0;i<cond.length;i++){ doc.text(cond[i], 14, 163 + i*5.5); }
    doc.setDrawColor(210,205,200); doc.setLineWidth(0.3); doc.line(14, 272, 196, 272);
    doc.setFontSize(8.2); doc.setTextColor(110,105,100);
    doc.text('FASTCO \u00b7 fastco.mx \u00b7 WhatsApp 56 3002 5938 \u00b7 team-bsm@brainstore.com.mx', 14, 278);
    doc.text('BSM Compa\u00f1\u00eda Internacional Multiservicios SA de CV \u00b7 M\u00e9xico', 14, 283);
    return doc;
  }
  form.addEventListener('submit', function(ev){
    ev.preventDefault();
    if(!form.reportValidity()) return;
    var d = {
      nombre: form.nombre.value.trim(),
      empresa: form.empresa.value.trim(),
      estado: form.estado.value,
      tel: form.telefono.value.trim(),
      correo: form.correo.value.trim(),
      qty: parseInt((document.getElementById('rentaQtyOut')||{}).textContent||'100',10)||100
    };
    var sub = d.qty * PRECIO, iva = Math.round(sub * 0.16), tot = sub + iva;
    var folio = 'FR-' + Date.now().toString(36).toUpperCase();
    var fecha = new Date().toLocaleDateString('es-MX', {day:'2-digit', month:'long', year:'numeric'});
    var btn = form.querySelector('.rf-btn');
    // El envio es automatico: PDF + correo. WhatsApp queda como opcion en la pantalla de gracias.
    function emitir(){
      try{
        var doc = construirPDF(d, folio, fecha, sub, iva, tot);
        var nombreArchivo = 'FASTCO-Cotizacion-Renta-' + folio + '.pdf';
        var blob = doc.output('blob');
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = nombreArchivo; document.body.appendChild(a); a.click(); a.remove();
        try{
          if(window.FASTCO_SW_ENDPOINT){
            var b64full = doc.output('datauristring');
            var b64 = b64full.substring(b64full.indexOf(',')+1);
            var payload = { folio: folio, pdf: b64, data: {
              servicio: 'renta', empresa: d.empresa, nombre: d.nombre, estado: d.estado,
              telefono: d.tel, correo: d.correo, cantidad: d.qty, total: mx(tot) + ' (IVA incl.)'
            }};
            fetch(window.FASTCO_SW_ENDPOINT, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)}).catch(function(){});
          }
        }catch(e){}
        var buy = (box && box.querySelector('.rent-buy')) || form.parentNode;
        var waTxt = encodeURIComponent('Hola, FastcoMX, acabo de enviar una solicitud de renta de toallas (folio ' + folio + ') desde su pagina web y quiero dar seguimiento.');
        var waHref = 'https://wa.me/' + (document.body.dataset.wa || '5215500000000') + '?text=' + waTxt;
        buy.innerHTML =
          '<div class="swq-done">' +
            '<span class="swq-done-ic"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"/></svg></span>' +
            '<h3>\u00a1Gracias! Su requerimiento ha sido enviado con \u00e9xito</h3>' +
            '<p>Recibimos su solicitud de renta con folio <b>' + folio + '</b> y la enviamos a nuestro equipo. Un especialista de Fastco le contactara a la brevedad. Su cotizacion en PDF se descargo como respaldo.</p>' +
            '<div class="swq-done-btns">' +
              '<a class="btn btn-solid swq-done-wa" href="' + waHref + '" target="_blank" rel="noopener"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 12a8.5 8.5 0 0 1-12.4 7.5L4 21l1.6-4.4A8.5 8.5 0 1 1 21 12z"/></svg> Contactar por WhatsApp</a>' +
              '<a class="btn btn-ghost swq-done-home" href="/">Cerrar y volver al inicio</a>' +
            '</div>' +
          '</div>';
      }catch(e){ if(btn){ btn.textContent = 'Solicitar cotizaci\u00f3n ahora'; } }
    }
    if(window.jspdf && window.jspdf.jsPDF){ emitir(); }
    else {
      btn.textContent = 'Generando cotizaci\u00f3n\u2026';
      var n = 0;
      var t = setInterval(function(){ n++; if(window.jspdf && window.jspdf.jsPDF){ clearInterval(t); emitir(); } else if(n > 40){ clearInterval(t); btn.textContent = 'Solicitar cotizaci\u00f3n ahora'; } }, 150);
    }
  });
})();
